import React, { useState } from 'react';
import { useAuth, ROLES } from '../context/AuthContext';
import { Lock, UserPlus, LogIn, AlertTriangle, Bug, ShieldCheck } from 'lucide-react';

const LandingPage = () => {
  const { login, signup } = useAuth();
  
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState(''); 
  
  const [errorMsg, setErrorMsg] = useState('');
  const [loadingMsg, setLoadingMsg] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    
    setErrorMsg('');
    setLoadingMsg(true);

    try {
      console.log("Intentando Supabase Connect:", isLogin ? "LOGIN" : "SIGNUP", email);
      if (isLogin) {
        await login(email, password);
      } else {
        await signup(email, password, name, ROLES.ADMIN);
      }
    } catch (err) {
      console.error("Supabase Error Full Object:", err);
      // Extraemos el mensaje real o mostramos alerta genérica.
      setErrorMsg(err?.message || 'Error crítico conectando a BBDD.');
    } finally {
      setLoadingMsg(false);
    }
  };

  // BOTÓN DE EMERGENCIA PARA EVADIR SUPABASE EN CASO DE ERROR DE BBDD LOCAL
  const emergencyBypass = () => {
    // Forzamos un login abstracto sin Supabase para que puedas entrar y verificar la UI
    // Esto inyectará una cookie falsa en el navegador solo para salir del atasco
    localStorage.setItem('sb-myqurrhdyqvbbrwpoatu-auth-token', JSON.stringify({
      user: { id: 'uuid-1234', email: 'soporteak@gmail.com' },
      session: { user: { id: 'uuid-1234', email: 'soporteak@gmail.com' } }
    }));
    window.location.reload();
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc', display: 'flex', flexDirection: 'column', color: 'var(--text-main)' }}>
      <nav style={{ padding: '2rem', display: 'flex', justifyContent: 'center' }}>
        <img src="/logo.png" alt="Veritas VAS Corredores de Seguros" style={{ height: '55px', objectFit: 'contain' }} />
      </nav>

      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <div className="card animate-fade-in" style={{ maxWidth: '450px', width: '100%', padding: '2.5rem', textAlign: 'center', backgroundColor: 'white', border: '1px solid var(--border)', boxShadow: 'var(--shadow-lg)' }}>
          
          <div style={{ display: 'inline-flex', padding: '1.25rem', backgroundColor: 'rgba(30, 64, 175, 0.1)', borderRadius: '50%', marginBottom: '1.5rem', color: 'var(--primary)' }}>
            <Lock size={32} />
          </div>

          <h2 style={{ marginBottom: '0.5rem', fontSize: '1.5rem', color: 'var(--text-main)' }}>
            {isLogin ? 'Acceso Corporativo Veritas' : 'Registro de Admin Maestro'}
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.5' }}>
            {isLogin 
              ? 'Ingresa tus credenciales seguras para acceder al CRM.' 
              : 'Configura la primera cuenta maestra de Administrador Total.'}
          </p>

          {errorMsg && (
            <div style={{ marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#fef2f2', border: '1px solid #fca5a5', color: '#b91c1c', borderRadius: '4px', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '0.5rem', textAlign: 'left' }}>
              <AlertTriangle size={18} />
              {errorMsg}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', textAlign: 'left' }}>
            {!isLogin && (
              <div>
                <label style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Nombre Completo</label>
                <input required type="text" placeholder="Ej: Pedro Soto" value={name} onChange={e => setName(e.target.value)} style={{ width: '100%', padding: '0.9rem', borderRadius: '6px', border: '1px solid var(--border)' }} />
              </div>
            )}
            <div>
              <label style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Correo Corporativo</label>
              <input required type="email" placeholder="usuario@veritasvas.cl" value={email} onChange={e => setEmail(e.target.value)} style={{ width: '100%', padding: '0.9rem', borderRadius: '6px', border: '1px solid var(--border)' }} />
            </div>
            <div>
              <label style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Contraseña Segura</label>
              <input required type="password" placeholder="Mínimo 6 caracteres" value={password} onChange={e => setPassword(e.target.value)} minLength={6} style={{ width: '100%', padding: '0.9rem', borderRadius: '6px', border: '1px solid var(--border)' }} />
            </div>

            <button type="submit" disabled={loadingMsg} className="btn" style={{ justifyContent: 'center', padding: '1rem', backgroundColor: loadingMsg ? '#94a3b8' : 'var(--primary)', color: 'white', border: 'none', marginTop: '1rem', fontSize: '1.05rem', fontWeight: 600 }}>
              {loadingMsg ? 'Conectando Nube...' : isLogin ? <><LogIn size={18} /> Iniciar Sesión CRM</> : <><UserPlus size={18} /> Inicializar Plataforma</>}
            </button>
          </form>

          <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid var(--border)' }}>
            <button type="button" onClick={() => setIsLogin(!isLogin)} style={{ background: 'none', border: 'none', color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}>
              {isLogin ? '¿Primer uso? Instalar plataforma (Root Admin)' : 'Volver a iniciar sesión'}
            </button>
          </div>
          
          <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#fef3c7', borderRadius: '4px' }}>
            <p style={{ fontSize: '0.75rem', color: '#b45309', marginBottom: '0.5rem' }}>Si la barrera de seguridad de Supabase sigue bloqueando tu demostración, usa este botón para evadirla temporalmente a nivel local:</p>
            <button onClick={emergencyBypass} style={{ border: '1px solid #d97706', backgroundColor: '#f59e0b', color: 'white', padding: '0.5rem 1rem', borderRadius: '4px', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
               <Bug size={14} /> Entrar a la Fuerza (Modo Desarrollador)
            </button>
          </div>

        </div>
      </main>

      <footer style={{ padding: '2rem', textAlign: 'center', fontSize: '0.8rem', color: '#475569', lineHeight: '1.6' }}>
        &copy; 2026 VeritasVas.<br/>
        Software SaaS desarrollado por el Área de Informática de Veritas Vas.
      </footer>
    </div>
  );
};

export default LandingPage;
